import urlParser from 'bloko/common/urlParser';

import { Requirements } from 'app/routes';

import { Action } from 'store/createReducer';
import { PayerDetail } from 'store/models/payerDetail';
import {
    FilterPayerType,
    PayerFilterType,
    setFilterPayerType,
    setFilterType,
    setFilterValue,
    setFilterWithoutAgreement,
    setPayers,
} from 'store/models/payers';

const LIMIT_PAYERS = 100;

const CACHE_OPTIONS = { cacheable: false };

const PayersRequirements: Requirements<{
    payers: PayerDetail[];
}> = {
    methods: ({ state }) => {
        const url = '/api/v1/backoffice/payers';
        const { type, value, payerType, withoutAgreement } = state.router.location.query;
        const params: Record<string, string> = {};
        if (type && value) {
            params.type = type;
            params.value = value;
        }
        if (payerType) {
            params.payerType = payerType;
        }
        if (withoutAgreement) {
            params.withoutAgreement = withoutAgreement;
        }
        if (Object.keys(params).length > 0) {
            const queryStr = urlParser.stringify(params);
            return { payers: { url: `${url}?${queryStr}`, ...CACHE_OPTIONS } };
        }
        return { payers: { url: `${url}?limit=${LIMIT_PAYERS}`, ...CACHE_OPTIONS } };
    },
    resolve: ({ result: { payers }, state }) => {
        const actions: Action[] = [setPayers(payers)];
        const { type, value, payerType, withoutAgreement } = state.router.location.query;
        if (type && value) {
            actions.push(setFilterType(type as PayerFilterType));
            actions.push(setFilterValue(value));
        }
        if (payerType) {
            actions.push(setFilterPayerType(payerType as FilterPayerType));
        }
        if (withoutAgreement) {
            actions.push(setFilterWithoutAgreement(withoutAgreement === 'true'));
        }
        return actions;
    },
};

export default PayersRequirements;
